import LoginIcon from '@mui/icons-material/Login';
import { CircularProgress, Link } from '@mui/material';
import { useState } from 'react';
import { defineMessage, FormattedMessage } from 'react-intl';

import { useAuth0LoginRedirect } from '../useAuth0LoginRedirect';

const loginBtnMessage = defineMessage({
  id: 'auth.loginScreen.loginBtn',
  defaultMessage: 'Iniciar sesión',
});

/**
 * Triggers Auth0 redirect. Used on the login_error screen so the user can retry.
 */
export function LoginButton() {
  const login = useAuth0LoginRedirect();
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      await login();
    } catch {
      setLoading(false);
    }
  };

  return (
    <Link
      component="button"
      type="button"
      underline="hover"
      color="primary"
      onClick={handleLogin}
      sx={{
        typography: 'body1',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        cursor: loading ? 'default' : 'pointer',
        border: 'none',
        background: 'none',
        p: 0,
        opacity: loading ? 0.7 : 1,
      }}
    >
      {loading ? <CircularProgress size={14} color="inherit" /> : <LoginIcon fontSize="small" />}
      <FormattedMessage {...loginBtnMessage} />
    </Link>
  );
}
